module.exports = __webpack_public_path__ + "img/setup_selected.b47f857e.png";